// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const aboBackgroundDetailsAPI = createApi({
  reducerPath: 'aboBackgroundDetailsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAboBackgroundDetails: builder.query<any, UserSpecificArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/abobackground`,
        method: 'GET',
      }),
    }),
    setAboBackgroundDetails: builder.mutation<any, ABOBackgroundMutationArgType>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/abobackground`,
        method: 'PUT',
        data: payload,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAboBackgroundDetailsQuery, useSetAboBackgroundDetailsMutation } =
  aboBackgroundDetailsAPI;
